import BaseEnumType from "../../common/base-enum-type";

const PenaltyType = Object.freeze({
    TwelveMenOnTheField: new BaseEnumType("12", "Too Many Men On The Field"),
    TooManyMenInTheHuddle: new BaseEnumType("TH", "Too Many Men In The Huddle"),
    AbuseOfOfficials: new BaseEnumType("AB", "Abuse of Officials (misconduct)"),
    IllegalBatting: new BaseEnumType("BB", "Illegal Batting"),
    IllegalBlock: new BaseEnumType("BL", "Illegal Block"),
    Clipping: new BaseEnumType("CL", "Clipping"),
    IllegalCut: new BaseEnumType("CUT", "Illegal Cut"),
    DelayOfGame: new BaseEnumType("DG", "Delay of Game"),
    Encroachment: new BaseEnumType("EN", "Encroachment"),
    WrongEquipment: new BaseEnumType("EG", "Wrong Equipment (kneepads)"),
    IllegalFairCatchSign: new BaseEnumType("FC", "Illegal Fair Catch Sign"),
    FaceMask: new BaseEnumType("FM", "Face Mask"),
    IllegalFormation: new BaseEnumType("FO", "Illegal Formation"),
    IllegalForwardPass: new BaseEnumType("FP", "Illegal Forward Pass"),
    FalseStart: new BaseEnumType("FS", "False Start"),
    IllegalHelmetContact: new BaseEnumType("HC", "Illegal Helmet Contact"),
    Holding: new BaseEnumType("HO", "Holding"),
    HelpingRunner: new BaseEnumType("HR", "Helping Runner"),
    IneligibleManDownfield: new BaseEnumType("ID", "Ineligible Man Downfield"),
    IneligibleReceiverDownfield: new BaseEnumType(
        "IRD",
        "Ineligible Receiver Downfield"
    ),
    IntentionalGrounding: new BaseEnumType("IG", "Intentional Grounding"),
    KickCatchingInterference: new BaseEnumType(
        "KI",
        "Kick Catching Interference"
    ),
    IllegalKicking: new BaseEnumType("KK", "Illegal Kicking"),
    IllegalKickoff: new BaseEnumType("KO", "Illegal Kickoff"),
    IllegalMotion: new BaseEnumType("MO", "Illegal Motion"),
    NonContactFoul: new BaseEnumType("NF", "Non Contact Foul"),
    Offside: new BaseEnumType("OS", "Offside"),
    OffsideDefense: new BaseEnumType("OD", "Offside Defense"),
    IllegalParticipation: new BaseEnumType("PA", "Illegal Participation"),
    PlayerDisqualification: new BaseEnumType("PD", "Player Disqualification"),
    PersonalFoul: new BaseEnumType("PF", "Personal Foul"),
    PassInterference: new BaseEnumType("PI", "Pass Interference"),
    RoughingThePasser: new BaseEnumType("RP", "Roughing the Passer"),
    RoughingTheHolder: new BaseEnumType("RH", "Roughing the Holder"),
    RoughingTheKicker: new BaseEnumType("RK", "Roughing the Kicker"),
    RoughingTheSnapper: new BaseEnumType("RS", "Roughing the Snapper"),
    IllegalShift: new BaseEnumType("SH", "Illegal Shift"),
    SidelineInterference: new BaseEnumType("SI", "Sideline Interference"),
    SubstitutionInfraction: new BaseEnumType("SU", "Substitution Infraction"),
    IllegalTouching: new BaseEnumType("TO", "Illegal Touching"),
    Tripping: new BaseEnumType("TR", "Tripping"),
    UnsportsmanLikeConduct: new BaseEnumType("UC", "Unsportsmanlike Conduct"),
    IllegalUseOfTheHands: new BaseEnumType("UH", "Illegal Use Of The Hands"),
    OF: new BaseEnumType("OF", "OF"),
    IllegalProcedure: new BaseEnumType("IP", "Illegal Procedure"),
    KickedOutOfBounds: new BaseEnumType("KOB", "Kicked Out of Bounds"),
    BlindSideBlock: new BaseEnumType("BSB", "Blind Side Block"),
    BlindSideBlockWithTargeting: new BaseEnumType(
        "BST",
        "Blind Side Block With Targeting"
    ),
    ChopBlock: new BaseEnumType("CHB", "Chop Block"),
    DefensePassInterference: new BaseEnumType(
        "DPI",
        "Defense Pass Interference"
    ),
    OffensivePassInterference: new BaseEnumType(
        "OPI",
        "Offensive Pass Interference"
    ),
    HorseCollarTackle: new BaseEnumType("HCT", "Horse Collar Tackle"),
    HandsToTheFace: new BaseEnumType("HTF", "Hands To The Face"),
    Hurdling: new BaseEnumType("HUR", "Hurdling"),
    IllegalBlockInTheBack: new BaseEnumType("IBB", "Illegal Block In The Back"),
    IllegalSnap: new BaseEnumType("ISP", "Illegal Snap"),
    BlockBelowTheWaist: new BaseEnumType("BW", "Block Below The Waist"),
    BlockingFromTheRear: new BaseEnumType("BR", "Blocking from the Rear"),
    CrackbackBlock: new BaseEnumType("CB", "Crackback Block"),
    DelayedKneeBlock: new BaseEnumType("DK", "Delayed Knee Block"),
    IllegalWedgeFormation: new BaseEnumType("IWF", "Illegal Wedge Formation"),
    Leaping: new BaseEnumType("LEA", "Leaping"),
    OffsideFreeKick: new BaseEnumType("XOF", "Offside Free Kick"),
    PersonalFoulLateHit: new BaseEnumType("PLH", "Personal Foul Late Hit"),
    RunningIntoTheKicker: new BaseEnumType("RNK", "Running Into The Kicker"),
    Fighting: new BaseEnumType("FGT", "Fighting"),
    Targeting: new BaseEnumType("TGT", "Targeting"),
    TargetingDisqualification: new BaseEnumType(
        "TD",
        "Targeting Disqualification"
    ),
    UnsportsmanlikeConductTaunting: new BaseEnumType(
        "UNT",
        "Unsportsmanlike Conduct Taunting"
    ),
    UnnecessaryRoughness: new BaseEnumType("UNR", "Unnecessary Roughness"),
    TwoOcPenaltiesDisqualification: new BaseEnumType(
        "O2",
        "2 OC Penalties Disqualification"
    ),
    ThreeUrPenaltiesDisqualification: new BaseEnumType(
        "U3",
        "3 UR Penalties Disqualification"
    ),
    DiscriminatoryRemarks: new BaseEnumType("DR", "Discriminatory Remarks"),
    DiscriminatoryRemarksDisqualification: new BaseEnumType(
        "DD",
        "Discriminatory Remarks Disqualification"
    ),
    IllegalContactOnAnEligibleReceiver: new BaseEnumType(
        "CR",
        "Illegal Contact On An Eligible Receiver"
    ),
    IllegalEquipment: new BaseEnumType("EQ", "Illegal Equipment"),
    IllegalInterferenceOnALooseBall: new BaseEnumType(
        "LB",
        "Illegal Interference On A Loose Ball"
    ),
    IllegalInterferenceOnTheKicker: new BaseEnumType(
        "IK",
        "Illegal Interference On The Kicker"
    ),
    IllegalSubstitution: new BaseEnumType("IS", "Illegal Substitution"),
    IllegalReceiver: new BaseEnumType("ILR", "Illegal Receiver"),
    InterferenceByUnauthorizedPersons: new BaseEnumType(
        "GG",
        "Interference By Unauthorized Persons"
    ),
    NoMouthguard: new BaseEnumType("MG", "No Mouthguard"),
    NoMouthguardWarning: new BaseEnumType("MW", "No Mouthguard Warning"),
    NoYards: new BaseEnumType("NY", "No Yards"),
    ObjectionableConduct: new BaseEnumType("OC", "Objectionable Conduct"),
    ObjectionableConductDisqualification: new BaseEnumType(
        "XOC",
        "Objectionable Conduct Disqualification"
    ),
    PilingOn: new BaseEnumType("PO", "Piling On"),
    RoughPlayDisqualification: new BaseEnumType(
        "RD",
        "Rough Play Disqualification"
    ),
    Spearing: new BaseEnumType("SP", "Spearing"),
    TandemBuck: new BaseEnumType("TB", "Tandem Buck"),
    TimeCountViolation: new BaseEnumType("TC", "Time Count Violation"),
    ContactingTheKicker: new BaseEnumType("CK", "Contacting The Kicker"),
    FanInterference: new BaseEnumType("FI", "Fan Interference"),
    FlagGuarding: new BaseEnumType("FG", "Flag Guarding"),
    Screening: new BaseEnumType("SC", "Screening"),
    Diving: new BaseEnumType("DV", "Diving"),
    Jumping: new BaseEnumType("JMP", "Jumping"),
    IllegalRush: new BaseEnumType("IRX", "Illegal Rush"),
    Tackling: new BaseEnumType("TCK", "Tackling"),
    IllegalFlagPull: new BaseEnumType("IFP", "Illegal Flag Pull"),
    ImpedingTheRusher: new BaseEnumType("IPR", "Impeding the Rusher"),
    Stripping: new BaseEnumType("STR", "Stripping"),
    Shielding: new BaseEnumType("SHD", "Shielding")
});

export default PenaltyType;
